<template>
    <div>
        <barraprincipalpsp @abrir="mtMenuVisible"> </barraprincipalpsp>
        <menulateral @cerrar="mtMenuVisible" :value="menu_visible"> </menulateral>
         <!-- //TODO agragar numero de tarjeta -->
        <v-container fluid>

            <div class="claro elevation-5">
                <v-row dense>     
                    <v-col cols="12" md="12" class="d-flex align-center px-4">
                        <h2 class="primary--text">Contratos asignados.</h2>                    
                    </v-col>                    
                </v-row>
            </div>      

            <br>                  

            <v-row>
                <v-col cols="12" md="12">
                    <div class="mx-0">
                        <v-data-table
                            dense
                            :headers="tabla_encabezado"
                            :items="contratos"
                            :item-class="color_fondo"
                            :items-per-page="-1"
                            class="elevation-1"
                            mobile-breakpoint="100"
                            multi-sort
                            :search="busqueda"
                            loading-text="Consultando información..."
                            :loading="cargando"
                            no-data-text="No se encontró información."
                            locale="es-MX"
                            :footer-props="{
                                'items-per-page-text':'Elementos por página',
                                'items-per-page-all-text': 'Todos',
                                'show-current-page':true,
                                'show-first-last-page': true,
                                'page-text':page_text
                            }"
                            @pagination="texto_paginacion"
                        >

                        <!-- Acciones -->
                        <template v-slot:item.acciones="{ item }">
                            <div class="d-flex justify-end">                             
                                <v-btn v-if="item.estatus == 2" title="Archivos adjuntos" icon color="primary" @click="abrirDialogoArchivos(item.cservicio)"><v-icon>mdi-paperclip</v-icon></v-btn>                            
                                <v-btn v-if="item.estatus == 2" title="Infomacion para factura" icon color="primary" @click="informacionParaFactura(item.cservicio)"><v-icon>mdi-information-outline</v-icon></v-btn>                            
                                <v-btn title="Imprimir contrato" icon color="success" @click="imprimirContrato(item.ccontrato, item.estatus)"><v-icon>mdi-printer-outline</v-icon></v-btn>
                            </div>
                        </template>

                        </v-data-table>
                    </div>
                </v-col>
            </v-row>              

            <!-- </div> -->

            <v-dialog v-model="cargando" v-if="cargando" max-width="300" persistent>
                <v-card>
                    <v-card-text class="d-flex justify-center">
                        <b class="mt-5">Consultando información</b>
                    </v-card-text>
                    <v-card-text>
                        <v-progress-linear indeterminate color="success"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dlarchivosadjuntos" v-if="dlarchivosadjuntos" max-width="600" transition="dialog-top-transition">
                <v-card>
                    <v-card-title class="d-flex justify-center primary--text">
                        Archivos adjuntos
                    </v-card-title>
                    <br><br>
                    <v-card-text class="d-flex flex-column justify-center">
                        <v-progress-circular v-if="consultandoadjuntos" indeterminate color="primary"></v-progress-circular>

                        <div v-for="(archivo, index) in archivosadjuntos" :key="index" class="d-flex flex-column">
                            <div class="my-2">
                                <v-btn @click="descargarArchivo(idservicioeditado, archivo)" dense> 
                                    {{archivo}} 
                                    <v-icon color="primary" class="ml-3">mdi-download</v-icon>
                                </v-btn>
                            </div>
                        </div>

                        <div v-if="archivosadjuntos.length == 0 && consultandoadjuntos == false">
                            No hay archivos adjuntos
                        </div>

                    </v-card-text>
                    <br><br>
                    <v-card-text class="d-flex">
                        <v-file-input hide-details="true" v-model="archivoadjunto" label="Factura pdf/xml" dense outlined></v-file-input>
                        <v-btn @click="enviarArchivo(idservicioeditado, archivoadjunto)" class="ml-3" color="primary" :loading="enviandoarchivo" dense>Enviar</v-btn>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end" @click="dlarchivosadjuntos = false">
                        <v-btn color="error" dense>
                            Cerrar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-snackbar v-model="snackbar" :color="snackbarcolor" light >
                <div class="d-flex justify-center"><strong>{{snackbartexto}}</strong></div>
            </v-snackbar>

            <dialogoconfirmacion ref="dialogoconfirmacion"></dialogoconfirmacion>
        </v-container>
    </div>
</template>

<script>

import menulateral from "@/components/MenuLateralPSP";
import barraprincipalpsp from "@/components/BarraPrincipalPSP";
import dialogoconfirmacion from '@/components/DialogoConfirmacion'
//const numeral = require('numeral')

export default {

    components:{
        menulateral,
        barraprincipalpsp,
        dialogoconfirmacion,
    },

    data() {
        return {
            menu_visible: false,
           
            snackbartexto: "",
            snackbar: false,
            snackbarcolor: "",

            busqueda:'',
            tabla_encabezado:[],
            contratos: [],
            page_text:'',
            cargando: true,
            color_fondo:"blue lighten-4",
           
            subtotal: 0.0,
            iva: 0.0,
            ret_iva: 0.0,
            ret_isr: 0.0,

            //Edicion
            idservicioeditado: 0,
         
            dlarchivosadjuntos: false,
            archivoadjunto: null,
            consultandoadjuntos: false,
            archivosadjuntos: [],
            enviandoarchivo: false,
            porcentaje_subido: ''

        }
    },

    beforeCreate() {
        const token = sessionStorage.getItem('dataex')

        this.axios.post(this.$url+'/acceso/validatoken/usuario', {}, {headers: {Authorization: `Bearer ${token}`}})
            .then((response)=>{

                const data = response.data

                if(data.codigo == 'lgout')
                     this.$router.push({"name":'Login'})

            })
            .catch((error)=>{
                console.log("Error "+error);
            })
    },

    created(){
        this.getContratos()
       // this.getFechaLarga()
    },

    methods: {
        mtMenuVisible(value){
            this.menu_visible = value
        },

        texto_paginacion: function(pg){
            this.page_text = 'Total elementos '+pg.itemsLength
        },

        getContratos(){
            const token = sessionStorage.getItem('dataex')

            this.cargando = true
            this.contratos = []
            this.axios.get(this.$url+'/psp/contratos/listado', {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data

                    if(!data.error){
                        //Encabezados de la tabla
                        this.tabla_encabezado = []
                        for(let key in data.contratos[0])
                            if(key == 'contrato' || key == 'servicio' || key == 'partida' || key == 'subtotal' || key == 'iva' || key == 'iva_ret' || key == 'isr_ret' || key == 'monto' || key == 'fecha_alt' || key == 'estado')
                                this.tabla_encabezado.push({
                                    text:key.toUpperCase(),
                                    value:key,
                                    class:"black--text"
                                })

                        //Agrego la columna de acciones a la tabla
                        this.tabla_encabezado.push({
                            text:"ACCIONES",
                            value:"acciones",
                            class:"black--text"
                        })

                        this.contratos = data.contratos
                    }
                    else{
                        console.log(data.mensaje);
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                        if(data.codigo == 'lgout')
                            this.$router.push({name:'PSPLogin'})
                    }
                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },

        imprimirContrato(idcontrato, estatus){

            let tipo = 'B'
            if(estatus == 1)
                tipo = 'B'
            if(estatus == 2)
                tipo = 'F'
            

            const token = sessionStorage.getItem('dataex')
            this.cargando = true
            this.axios.get(this.$url+'/psp/contratos/pdfcontrato/'+idcontrato+'/'+tipo,
                    {
                        headers: {Authorization:`Bearer ${token}`},
                        responseType: 'blob'
                    })
                .then((response)=>{
                    const tipo_contenido = response.headers['content-type']
                    const file = new Blob([response.data], {type:tipo_contenido});                    
                    const fileURL = URL.createObjectURL(file)
                    window.open(fileURL)
                })
                .catch((error)=>{
                    console.log(error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },

        abrirDialogoArchivos(cservicio){
            this.obtenerArchivosAdjuntos(cservicio)
            this.idservicioeditado = cservicio
            this.dlarchivosadjuntos = true
        }, 

        obtenerArchivosAdjuntos(cservicio){
            const token = sessionStorage.getItem('dataex')

            this.consultandoadjuntos = true
            this.axios.get(this.$url+'/psp/contratos/archivosadjuntos/'+cservicio, {headers:{"authorization":`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data

                    if(!data.error){
                        this.archivosadjuntos = data.adjuntos
                    }
                    else{
                        this.snackbarcolor = "error"
                        this.snackbartexto = data.mensaje
                        this.snackbar = true

                    }


                })
                .finally(()=>{
                    this.consultandoadjuntos = false
                })

        },  

        enviarArchivo(cservicio, archivo){    
            
            if(!archivo)
                return

            console.log(archivo.type);

            if (archivo.type != 'application/pdf' && archivo.type != 'text/xml') {               
                this.snackbartexto = "Tipo de archivo no valido..."
                this.snackbarcolor = 'error'
                this.snackbar = true
                return                   
            }
           

            if( (archivo.size / 1024) > 5120 ){
                this.snackbartexto = "Archivo supera el tamaño maximo 5mb"
                this.snackbarcolor = "error"
                this.snackbar = true
                return
            }

            const token = sessionStorage.getItem('dataex')

            let data = new FormData();
            data.set('enctype', 'multipart/form-data')
            data.append("cservicio", cservicio)
            data.append("file", archivo)
            data.append('_method', 'PUT')

            this.enviandoarchivo = true
            this.axios.put(this.$url+'/psp/contratos/adjuntararchivo', data,                         
                        {
                            headers: {Authorization: `Bearer ${token}`},
                            onUploadProgress: progressEvent =>{                            
                                this.porcentaje_subido ='Subiendo archivos... '+ Math.round(progressEvent.loaded / progressEvent.total * 100) + "%"                                
                            }
                        }                        
                    )
                .then((response)=>{

                    if(response.data){
                        if(response.data.error){
                            this.snackbar = true;
                            this.snackbarcolor = "error";
                            this.snackbartexto = response.data.mensaje
                        }
                        else{
                            this.snackbar = true;
                            this.snackbarcolor = "success";
                            this.snackbartexto = response.data.mensaje
                            this.archivoadjunto = null
                            this.obtenerArchivosAdjuntos(cservicio)
                        }
                    }
                    else{
                        this.snackbar = true;
                        this.snackbar_color = "error";
                        this.snackbar_texto = "Error al subir documentos, intente mas tarde." 
                    }
                })
                .catch(()=>{
                    this.snackbar = true;
                    this.snackbar_color = "error";
                    this.snackbar_texto = "Error al subir documentos, intente mas tarde."                    
                })
                .finally(()=>{
                    this.enviandoarchivo = false
                })
        },

        descargarArchivo(cservicio, archivo){            
            const token = sessionStorage.getItem('dataex')
            const data = {
                cservicio: cservicio,
                archivo: archivo
            }

            //Funciona bien en Firefox
            this.axios.post(this.$url+"/psp/contratos/archivosadjuntos/descargar", {data:data}, 
                    {
                        headers: {Authorization: `Bearer ${token}`},
                        responseType: 'blob'
                    })
          
                .then((response)=>{  

                    if(response.data.error)
                        return

                    const tipo_contenido = response.headers['content-type']
                    const file = new Blob([response.data], {type:tipo_contenido});                            
                    const fileURL = URL.createObjectURL(file)
                    window.open(fileURL)

                })
                .catch((error)=>{
                    console.log("Descarga archivo "+error);
                })
        },

        informacionParaFactura(idservicio){
            const token = sessionStorage.getItem('dataex')

            this.axios.get(this.$url+'/psp/contratos/pdfinformacionpago/'+idservicio, {headers:{Authorization:`Bearer ${token}`}, responseType: 'blob'})
                .then((response)=>{                    
                    const tipo_contenido = response.headers['content-type']
                    const file = new Blob([response.data], {type:tipo_contenido});                            
                    const fileURL = URL.createObjectURL(file)
                    window.open(fileURL)
                })
                .catch((error)=>{
                    console.log("Ocurrio un error");
                    console.log(error);
                })
                .finally(()=>{
                    
                })
        }

    },
}
</script>


<style>
    .contrato{
        font-size: 16px;
        color: black;
        margin-block-start: 10px;
        margin-block-end: 10px;
        padding-left: 5px;
        padding-right: 5px;
    }
    .nombrepersonal{
        max-width: 350px !important;
    }
    .oficio{
        max-width: 100px !important;
    }
    .fecha{
        max-width: 230px !important;
    }
    .partida{
        max-width: 200px !important;
    }
    .circular{
        max-width: 140px !important;
    }
    .rfc{
        max-width: 300px !important;
    }
    .anio{
        max-width: 79px !important;
    }

</style>
